module.exports = __webpack_public_path__ + "assets/1a0e756f0d75005af32c941569143385.png";